/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{r as s,p as r,g as o}from"../../../../../chunks/vec32.js";import{c,g as n}from"../../../../../chunks/sphere.js";const t=1e3;function e(t,e,a){const p=c(),m=n(p);return s(m,m,t,.5),s(m,m,e,.5),p[3]=r(m,t),o(m,m,a),p}export{e as boundsFromEdge,t as maxCandidateCount};
